import React from 'react';
import { Player } from '@lottiefiles/react-lottie-player';

import loaderAnimation from '../../../lotties/Flight-Health-Loader-1-Json.json';

import './Loading.scss';

const Loading = () => {
  return (
    <div id="loading-container">
        <Player
            autoplay={true}
            loop={true}
            src={loaderAnimation}
            speed={1.5}
            style={{height: '100px', width: '100px'}}
        />
    </div>
  );
};

export default React.memo(Loading);
